export default "__VITE_ASSET__BTPOVfFQ__"